import { useContext } from 'react';

import { DataContext } from 'providers/data';

import Modals from 'components/views/Modals';
import { Typography, Box, CircularProgress } from '@mui/material';

import { BrDesk, TypographyCustom } from './style';

import IcCheckText from 'assets/images/ic-check-text-blue.png';
import ImgAttention from 'assets/images/attention-ic.png';
import ImgAttention2 from 'assets/images/attention-ic-2.png';
import { ReactComponent as IconClosed } from 'assets/icons/ic-closed-green.svg';

const ModalAlertSecutiry = () => {
    const { isShowModalAlert, isLoadingBanner, activeLoginBanner, handleAlertModal } = useContext(DataContext);

    const closeButton = (
        <Box sx={{
            position: 'absolute',
            right: { xs: '.3rem', md: '.9rem' },
            top: { xs: '.3rem', md: '.8rem' },
            cursor: 'pointer',
            zIndex: 2,
            'svg': {
                width: { xs: '1.5rem', md: '1.875rem' },
                height: 'auto'
            }
        }} onClick={() => handleAlertModal(false)}>
            <IconClosed />
        </Box>
    );

    if (isLoadingBanner) {
        return (
            <Modals open={isShowModalAlert} borderRadius='.8rem' bgcolor='transparent'>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '5rem', height: '5rem' }}>
                    <CircularProgress />
                </Box>
            </Modals>
        );
    }

    if (activeLoginBanner) {
        return (
            <Modals open={isShowModalAlert} borderRadius='.8rem' bgcolor='transparent'>
                <Box sx={{
                    position: 'relative',
                    width: { xs: 'calc(100vw - 2rem)', md: '37rem' },
                    borderRadius: '.81931rem',
                    overflow: 'hidden',
                    backgroundColor: 'white'
                }}>
                    {closeButton}
                    <Box
                        component='img'
                        src={activeLoginBanner}
                        alt='Aviso importante'
                        sx={{
                            display: 'block',
                            width: '100%',
                            height: 'auto',
                            borderRadius: '.81931rem'
                        }}
                    />
                </Box>
            </Modals>
        );
    }

    return (
        <Modals open={isShowModalAlert} borderRadius='.8rem' bgcolor='transparent'>
            <Box sx={{
                width: {
                    xs: 'calc(100vw - 2rem)',
                    md: '37rem'
                },
                height: { xs: 'auto', md: 'auto' },
                borderRadius: '.81931rem',
                backgroundColor: 'white',
            }}>
                <Box sx={{
                    position: 'absolute',
                    right: { xs: '.3rem', md: '.9rem' },
                    top: { xs: '.3rem', md: '.8rem' },
                    cursor: 'pointer',
                    zIndex: '2',
                    'svg': {
                        width: { xs: '1.5rem', md: '1.875rem' },
                        height: 'auto'
                    }
                }} onClick={() => handleAlertModal(false)}>
                    <IconClosed />
                </Box>

                <Box sx={{
                    width: '100%',
                    position: 'relative',
                    height: { xs: '4rem', md: 'auto' },
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'primary.100',
                    borderRadius: '.6rem .6rem 0 0',
                    justifyContent: 'space-between',
                    padding: { xs: '0 1rem', md: '1.1rem 0 .8rem' },
                    'img': {
                        width: { xs: '3.3rem', md: 'auto' },
                    }
                }}>
                    <img src={ImgAttention2} alt="atencao" style={{ position: 'absolute', left: '1rem', height: '3.75rem', bottom: '.4rem' }} />
                    <Box sx={{
                        textAlign: 'center',
                        display: 'flex',
                        zIndex: 1,
                        flexDirection: { xs: 'column', md: 'row' },
                        justifyContent: 'center',
                        width: '100%',
                        columnGap: {
                            xs: '.3rem',
                            md: '1.19rem'
                        },
                        alignItems: 'center'
                    }}>
                        <Typography sx={{
                            width: 'fit-content',
                            fontSize: { xs: '.75rem', md: '1.125rem' },
                            fontWeight: 700,
                            backgroundColor: 'primary.light',
                            padding: { xs: '.2rem .2rem 0', md: '.6rem 0 .4rem' },
                            marginBottom: { xs: '.1rem', md: '0' },
                            color: 'white',
                            maxWidth: '8.875rem',
                        }}>
                            AVISO IMPORTANTE:
                        </Typography>
                        <Typography sx={{
                            fontSize: { xs: '.93rem', md: '1.5625rem' },
                            fontWeight: 700,
                            paddingTop: { xs: '.4rem', md: '.63rem' },
                            color: 'white',
                        }}>
                            Cuidado com golpes <br />
                            usando o nome da Ituran!
                        </Typography>
                    </Box>
                    <img src={ImgAttention} alt="atencao" style={{ position: 'absolute', right: '1rem', height: '3.75rem', bottom: '.4rem' }} />
                </Box>

                <Box sx={{ backgroundColor: 'white', height: 'calc(100% - 8.93rem)', padding: { xs: '.55rem .85rem', md: '1.47rem 1.38rem' }, overflowY: 'auto', maxHeight: 'calc(100vh - 12rem)' }}>
                    <Box sx={{ display: 'flex' }}>
                        <Box sx={{ width: '3px', height: '1rem', backgroundColor: 'secondary.main', marginRight: '.38rem' }} />
                        <Typography sx={{ fontSize: '.875rem', paddingTop: '.2rem', color: 'primary.100' }}>
                            Prezado cliente,
                        </Typography>
                    </Box>

                    <Typography sx={{ fontSize: '.875rem', padding: { xs: '.55rem 0', md: '1.22rem 0' }, lineHeight: '1.2', color: 'primary.100' }}>
                        <b>Informamos que fraudadores estão utilizando o nome da Ituran para aplicar <BrDesk />
                            golpes por mensagens de Whatsapp ou ligação telefônica,</b> alegando a necessidade <BrDesk />
                        de uma atualização de app, manutenção do rastreador via link ou suposto pagamento <BrDesk />
                        (via pix ou boleto) de mensalidade vencida.
                    </Typography>

                    <Typography sx={{
                        fontSize: '.875rem',
                        fontWeight: 700,
                        lineHeight: '1.05',
                        color: 'primary.100'
                    }}>
                        PEDIMOS A GENTILEZA QUE REFORCEM A ATENÇÃO E SIGAM AS ORIENTAÇÕES ABAIXO:
                    </Typography>

                    <Box sx={{
                        display: 'flex',
                        width: '100%',
                        paddingTop: { xs: '.55rem', md: '1.22rem' },
                        justifyContent: 'space-between',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: '.3rem',
                        'ul': {
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: { xs: '.3rem', md: '.6rem' },
                            paddingLeft: { xs: '.9rem', md: '1rem' }
                        },
                        'li': {
                            listStyleType: 'initial',
                        }
                    }}>
                        <ul>
                            <li>
                                <TypographyCustom>
                                    Todos os números oficias de Whatsapp da <BrDesk />
                                    Ituran possuem o selo de verificação da <BrDesk />
                                    Meta ao lado do nome, como este aqui:
                                    <img src={IcCheckText} alt="ic-check" />
                                </TypographyCustom>
                            </li>
                            <li>
                                <TypographyCustom>
                                    A lturan <b>NUNCA</b> realiza ligações por voz <br />
                                    via Whatsapp;
                                </TypographyCustom>
                            </li>
                            <li>
                                <TypographyCustom>
                                    A lturan <b>NUNCA</b> solicita as informações <br />
                                    financeiras dos nossos clientes ou envia sem <br />
                                    seu pedido, códigos PIX para pagamentos;
                                </TypographyCustom>
                            </li>
                            <li>
                                <TypographyCustom>
                                    A Ituran <b>NUNCA</b> indica a <br />
                                    instalação ou atualização do nosso <br />
                                    App por links via WhatsApp;
                                </TypographyCustom>
                            </li>
                            <li>
                                <TypographyCustom>
                                    A Ituran <b>NUNCA</b> atua de maneira <br />
                                    remota via link para a atualização <br />
                                    do nosso rastreador;
                                </TypographyCustom>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <TypographyCustom>
                                    Nosso App Ituran digital está <BrDesk />
                                    disponível somente nas loja oficiais <BrDesk />
                                    da Apple e Android;
                                </TypographyCustom>
                            </li>
                            <li>
                                <TypographyCustom>
                                    Antes de efetuar qualquer PIX, <BrDesk />
                                    confira o destinatário que deve ser <BrDesk />
                                    <b>Ituran Serviços Ltda;</b>
                                </TypographyCustom>
                            </li>
                            <li>
                                <TypographyCustom>
                                    Os boletos Ituran são enviados por <BrDesk />
                                    e-mail/SMS ou disponíveis dentro <BrDesk />
                                    do site, área de cliente App Ituran <BrDesk />
                                    digital ou nosso número oficial de <BrDesk />
                                    atendimento ao cliente no <BrDesk />
                                    WhatsApp (11 3616-9000).
                                </TypographyCustom>
                            </li>
                        </ul>
                    </Box>

                    <TypographyCustom sx={{ paddingTop: { xs: '.5rem', md: '.9rem' } }}>
                        Se suspeitar de algum contato feito em nome da Ituran, utilize nossos <b> canais de <BrDesk />
                            atendimento oficiais no site <a href="https://ituran.com.br/" target='blank'><u>ituran.com.br</u></a>, App Ituran Digital BR ou procure o <BrDesk />
                            seu corretor de seguros ou parceiro autorizado.</b>
                    </TypographyCustom>
                </Box>

                <Box sx={{ backgroundColor: '#7AC4D7', height: '1.45rem', borderRadius: ' 0 0 .8rem .8rem' }} />
            </Box>
        </Modals>
    )
}

export default ModalAlertSecutiry;